import React from "react";
import Link from "@mui/material/Link";

export default function ParamountPrivacyLink(props) {
  return (
    <Link color="textPrimary" target="_blank" underline="hover" {...props} />
  );
}
